import React from "react";
import withIconComponent from "../withIconComponent";

var ArrowRight = function ArrowRight() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 12h20",
    "data-cap": "butt",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5l7 7-7 7",
    strokeLinecap: "square"
  }));
};

export default withIconComponent("UiArrowRight", false)(ArrowRight);